const langs = {
        EN: { ietf: 'en', label: 'English', langDir: 'ltr' }
    },
    countries = {
        US: {
            ietf: 'US',
            label: 'United States',
            supportedLangs: [langs.EN.ietf],
            dateFormat: 'MM/DD/YYYY',
            abbreviation: 'USA'
        },
        CA: {
            ietf: 'CA',
            label: 'Canada',
            supportedLangs: [langs.EN.ietf],
            dateFormat: 'YYYY-MM-DD',
            darkLaunch: true,
            VAT: true,
            abbreviation: 'CAN'
        }
    },
    locales = {
        'en-us': {
            label: 'United States - English',
            htmlLang: langs.EN.ietf,
            hrefLang: `${langs.EN.ietf}-${countries.US.ietf}`
        },
        'en-ca': {
            label: 'Canada - English',
            htmlLang: langs.EN.ietf,
            hrefLang: `${langs.EN.ietf}-${countries.CA.ietf}`,
            darkLaunch: true
        }
    };

module.exports = { locales, countries, langs };
